import {
  appendStars
} from '../global/_appendStars';
import {
  formatPrice
} from '../global/_formatPrice';
import {
  isInternational
} from '../global/_checkForInternational';

export const zonePopulation = (zone, rec_attributes) => {
  var imgProfile = '/productItem';
  if (zone == 'JFYZ1' || zone == 'PDPZ2') imgProfile = '/productRec';

  if (rec_attributes && rec_attributes.length > 0) {
    var lines = [];
    for (var recNum = 0; recNum < rec_attributes.length; recNum++) {
      if (!isInternational() || (rec_attributes[recNum][8] === "true" && isInternational())) {
        var price_min = rec_attributes[recNum][6],
          catentry = rec_attributes[recNum][9];
        if (price_min != "0" && catentry != "503516586") {
          var imgSrc = rec_attributes[recNum][2].replace('http:', '').replace('.jpg',''),
            price_max = rec_attributes[recNum][7],
            product_description = decodeURI(rec_attributes[recNum][0].split("\u2122").join('&trade;').split(/[\u0250-\ue007]/g).join('').split("\uFFFD").join('').split('%2F').join('/').split('%22').join('&quot;').split('%26').join('&amp;').split('%E2%84').join('').split('%C2%AE').join('').split('%C2%A9').join('')),
            product_brand = rec_attributes[recNum][12],
            product_url = rec_attributes[recNum][1] + '?categoryId=' + zone,
            product_keyword = rec_attributes[recNum][1].split('/')[2],
            //stars = rec_attributes[recNum][3],
            priceRange = formatPrice(price_min) + ' - ' + formatPrice(price_max),
            priceHTML = (price_min === price_max) ? formatPrice(price_max) : priceRange,
    		  recInteractionData = rec_attributes[recNum][14];

          if (imgSrc != undefined && imgSrc.indexOf('//') == 0) {
            var imgSrcSplit = imgSrc.split('/');
            imgSrc = imgSrcSplit[imgSrcSplit.length - 1];
          }
          
          if(typeof recInteractionData === 'object' && Object.keys(recInteractionData).length > 0){
        	  recInteractionData = JSON.stringify(recInteractionData).split('"').join('&quot;');
          }

          lines.push('<li data-catentryid = "' + catentry + '">');
          if (product_description.toLowerCase().indexOf('chanel') == -1) {
            if ($('.modal-add-to-registry').length > 0) {
              lines.push(`<div class="image-wrap"><a href="${product_url}" id="qv-${catentry}" class="" data-modal-title="${product_description}" data-toggle="modal" data-target=".modal-quickview" data-novalidation data-modal-body="callQuickView({&quot;catentryId&quot;: &quot;${catentry}&quot;,&quot;categoryId&quot;: &quot;${zone}&quot;,&quot;regRec&quot;: &quot;true&quot;})" onclick="Peerius?.smartRecsClick(${recInteractionData})">`);
            } else {
              lines.push(`<div class="image-wrap"><a href="${product_url}" id="qv-${catentry}" class="" data-modal-title="${product_description}" data-toggle="modal" data-target=".modal-quickview" data-novalidation data-modal-body="callQuickView({&quot;catentryId&quot;: &quot;${catentry}&quot;,&quot;categoryId&quot;: &quot;${zone}&quot;})" onclick="Peerius?.smartRecsClick(${recInteractionData})">`);
            }
          } else {
            lines.push(`<div class="image-wrap"><a href="${product_url}" onclick="Peerius?.smartRecsClick(${recInteractionData})">`);
          }
          if (zone != 'ACMZ1') {
            lines.push(`<img src="/images/shim.gif" class="lazy-img" `);
          } else {
            lines.push(`<img src="//dimg.dillards.com/is/image/DillardsZoom/productRec/${product_keyword}/${imgSrc}.jpg" `);
          }
          lines.push(`data-original="//dimg.dillards.com/is/image/DillardsZoom/productRec/${product_keyword}/${imgSrc}.jpg" alt="Image of ${product_description}"/>`);
          if (zone == 'SCPZ2_RV') {
            if (document.querySelectorAll(".desktopPage").length > 0) {
              lines.push(`</a><button class="rv-remove" type="button" tabindex='0' aria-label="remove" onclick="window.removeRecentlyViewedProduct('${catentry}');"><svg class="closeSVG" height="11" width="11" viewBox="0 0 16 16" role="img" aria-labelledby="removeRVItem-${catentry}"><title id="removeRVItem-${catentry}">Remove ${product_description.split('"').join('#double;').replace(/\s+/g, ' ')} from recently viewed list</title><path d="M15.6,15.6c-0.5,0.5-1.4,0.5-1.9,0L8,9.9l-5.7,5.7c-0.5,0.5-1.4,0.5-1.9,0c-0.5-0.5-0.5-1.4,0-1.9L6.1,8L0.4,2.3c-0.5-0.5-0.5-1.4,0-1.9C0.7,0.1,1,0,1.3,0s0.7,0.1,1,0.4L8,6.1l5.7-5.7c0.5-0.5,1.4-0.5,1.9,0C15.9,0.7,16,1,16,1.3s-0.1,0.7-0.4,1L9.9,8l5.7,5.7C16.1,14.2,16.1,15.1,15.6,15.6z"/></svg></button>`);
            } else {
              lines.push(`</a><button class="rv-remove" type="button" tabindex='0' aria-label="remove" onclick="window.removeRecentlyViewedProduct('${catentry}');"><svg class="closeSVG" height="8" width="8" viewBox="0 0 16 16" role="img" aria-labelledby="removeRVItem-${catentry}"><title id="removeRVItem-${catentry}">Remove ${product_description.split('"').join('#double;').replace(/\s+/g, ' ')} from recently viewed list</title><path d="M15.6,15.6c-0.5,0.5-1.4,0.5-1.9,0L8,9.9l-5.7,5.7c-0.5,0.5-1.4,0.5-1.9,0c-0.5-0.5-0.5-1.4,0-1.9L6.1,8L0.4,2.3c-0.5-0.5-0.5-1.4,0-1.9C0.7,0.1,1,0,1.3,0s0.7,0.1,1,0.4L8,6.1l5.7-5.7c0.5-0.5,1.4-0.5,1.9,0C15.9,0.7,16,1,16,1.3s-0.1,0.7-0.4,1L9.9,8l5.7,5.7C16.1,14.2,16.1,15.1,15.6,15.6z"/></svg></button>`);
            }
          } 
          if (product_description.toLowerCase().indexOf('chanel') == -1) {
            if ($('.modal-add-to-registry').length > 0) {
              lines.push(`<a class="rec-title" href="${product_url}" id="rec-brand-${catentry}" class="" data-modal-title="${product_description}" data-toggle="modal" data-target=".modal-quickview" data-novalidation data-modal-body="callQuickView({&quot;catentryId&quot;: &quot;${catentry}&quot;,&quot;categoryId&quot;: &quot;${zone}&quot;,&quot;regRec&quot;: &quot;true&quot;})" onclick="Peerius?.smartRecsClick(${recInteractionData})">`);
            } else {
              lines.push(`<a class="rec-title" href="${product_url}" id="rec-brand-${catentry}" data-modal-title="${product_description}" data-toggle="modal" data-target=".modal-quickview" data-novalidation data-modal-body="callQuickView({&quot;catentryId&quot;: &quot;${catentry}&quot;,&quot;categoryId&quot;: &quot;${zone}&quot;})" onclick="Peerius?.smartRecsClick(${recInteractionData})"><p class="vert-rec-title">${product_brand}<span class="sr-only">Opens a quickview of ${product_brand}</span></p>`);
            }
          } else {
            lines.push(`<a class="rec-title" href="${product_url}" onclick="Peerius?.smartRecsClick(${recInteractionData})"><p class="vert-rec-title">${product_brand}<span class="sr-only">Opens a quickview of ${product_brand}</span></p>`);
          }
          lines.push('</a></div></li>');
        }
      }
    }
    return lines;
  }

};

window.removeRecentlyViewedProduct = (catentryIdToRemove) => {
	var recentlyViewedProducts = [];
	try{
		recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
	}catch(e){
		console.log(e);
	}
	for(var i = 0; i < recentlyViewedProducts.length; i++){
		var existingRecentlyViewedProduct = recentlyViewedProducts[i];
		if(existingRecentlyViewedProduct[9] == catentryIdToRemove){
			recentlyViewedProducts.splice(i, 1);
			localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewedProducts));
			break;
		}
	}
	
	try{
		for(var i = 0; i < $('.recently-viewed-results #horz-rec .rec-list li').length; i++){
		    if($($('.recently-viewed-results #horz-rec .rec-list li')[i]).attr('data-catentryid') == catentryIdToRemove){
		    	
		    	if ($('.desktopPage').length > 0) {
		             $('.recently-viewed-results #horz-rec .rec-list').slick('slickRemove', i);
		        }else{
		        	$($('.recently-viewed-results #horz-rec .rec-list li')[i]).remove();
		        } 
		        
		        if($('.recently-viewed-results #horz-rec .rec-list li').length == 0){
					$('.recently-viewed-results #horz-rec').hide();
				}
		        break;
		    }
		}
	}catch(e){
		console.log(e);
	}
}
